<template>
  <div>
      <div class="aa">
      <div class="bb">
        <div class="cc1">
          <img  src="../../../assets/home/logo.png" >
          <div class="dd1" >
            <div @click="aa = 1"  :style="[{color:aa == 1?'#409EFF':'#000000'},  {'border-bottom':aa == 1?  '4px solid #409EFF' : '4px solid rgb(253, 249, 249)'}]"   >
              <span>产品</span>
            </div>
            <div @click="aa = 0;"  :style="[{color:aa == 0?'#409EFF':'#000000'},  {'border-bottom':aa == 0?  '4px solid #409EFF' : '4px solid rgb(253, 249, 249)'}]"  >
              <span>应用场景</span>
            </div>
          </div>
          <i class="dd2 el-icon-circle-close " @click="guanbi"></i>
        </div>


        <div class="cc2">
          <div  class="ss">
            <el-input class="dd1" placeholder="请输入内容"></el-input>
            <el-button class="dd2" type="primary">搜索</el-button>
          </div>
          
        </div>
        <div class="cc3">
          <div class="ss">
            <div class="dd1">
                <el-image class="ee1" fit="contain"  :src="zhutu">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
                <!-- 标注位 -->
                <div  class="ff2"  v-for=" (itme,index) of xiangqing_mark" 
                    :key="itme.id" 
                    :style="{left:(itme.pos_left-10)*0.13333+'vw', top:(itme.pos_top-10)*0.13333+'vw'}"
                    @click="dian(index)"
                    v-show="bb"
                >
                  <el-tooltip   placement="right" :content="itme.title === '' || itme.title === 'null'? '暂无名称':itme.title" visible-arrow="false" >
                      <span>{{index+1}}</span>
                  </el-tooltip>

              </div>
              
            </div>
            <div class="dd2">
              <div class="ee1">
                <div    :style="[{color:bb == 1?'#409EFF':'#000000'},  {'border-left':bb == 1?  '4px solid #409EFF' : '4px solid #FFFFFF'}]" >
                  <span  v-if="aa" @click="zl_tu(1)">结构图</span>
                  <span  v-else     @click="bb = 1" >3D图</span>
                </div>
                <div  :style="[{color:bb == 0?'#409EFF':'#000000'},  {'border-left':bb == 0?  '4px solid #409EFF' : '4px solid #FFFFFF'}]" >
                  <span  v-if="aa"  @click="zl_tu(2)">原理示意图</span>
                  <span  v-else     @click="bb = 0"  >平面图</span>
                </div>
                <div><el-button class="ff1" type="primary" >我来补充</el-button></div>
              </div>
              
            </div>
          </div>

        </div>
        <div class="cc4">
          <img src="../../../assets/home/tu/1.jpeg" alt="">
        </div>

        <div class="cc5">
          
          <div class="dd1" v-for=" i in 6" :key="i">
            <el-image  class="ee1"   src="https://img1.baidu.com/it/u=1228645897,2925386248&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800"  fit="cover">
            </el-image>
            <div class="ee2">
              <span>你好你好</span>
            </div>
          </div>

         
          
        </div>

        <div class="cc6">
          <img src="../../../assets/home/tu/2.jpeg" alt="">
        </div>

        <div class="cc5">

          <div class="dd1" v-for=" i in 6" :key="i">
            <el-image  class="ee1"   src="https://img1.baidu.com/it/u=1228645897,2925386248&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800"  fit="cover">
            </el-image>
            <div class="ee2">
              <span>你好你好</span>
            </div>
          </div>

        </div>

        <div class="cc8">
          <img src="../../../assets/home/tu/3.jpeg" alt="">
        </div>

        <div class="cc5">

          <div class="dd1" v-for=" i in 6" :key="i">
            <el-image  class="ee1"   src="https://img1.baidu.com/it/u=1228645897,2925386248&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800"  fit="cover">
            </el-image>
            <div class="ee2">
              <span>你好你好</span>
            </div>
          </div>
          
        </div>

        <div class="cc10">
          <img src="../../../assets/home/tu/4.jpeg" alt="">
        </div>

        <div class="cc5">
          
          <div class="dd1" v-for=" i in 6" :key="i">
            <el-image  class="ee1"   src="https://img1.baidu.com/it/u=1228645897,2925386248&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800"  fit="cover">
            </el-image>
            <div class="ee2">
              <span>你好你好</span>
            </div>
          </div>
        </div>


      </div>
    </div>
    <el-dialog title="相关商品" :visible.sync="xiang" v-if="xiang" :append-to-body="true" :lock-scroll="false"  width="1200px" > 
      <div class="aaa">
        <div class="bbb">
          <div class="ccc1">
            <div class="ddd1" v-for="(imte) of chanpin_mark" :key="imte.id">
              <div class="eee1">
                <el-image :src="img_url+imte.product_image"  fit="fill" ></el-image>
              </div>
              <div class="eee2">
                <div class="fff1"><span>{{imte.product_title}}</span></div>
                <div class="fff2"><span>{{imte.product_desc}}</span></div>
              </div>
            </div>
          </div>         
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name:'tu',
        data(){
          return{
            aa:1,
            bb:1,
            img_src1_zl:'',
            img_src1_yl:'',
            xiangqing_mark:[],
            xiangqing_title:'',
            img_url:'',
            xiang:0,
            chanpin_mark:[],
            zhutu:''
          }
        },
        methods:{
          get_shuju(){
            var t = this;
            t.img_url = window.config.api_url +'/storage/';
            var url = window.config.api_url+'/college/exhibition/'+t.$route.params.id
            t.axios.get(url).then(function(res){
              t.img_src1_zl = t.img_url + res.data.image
              t.zhutu = t.img_url + res.data.image
              t.img_src1_yl = t.img_url + res.data.diagram
              t.xiangqing_mark = res.data.mark
              t.xiangqing_title = res.data.title
            })  
          },
          zl_tu(index){
            if(index == 1){
              this.bb = 1
              this.zhutu = this.img_src1_zl
            }else if(index == 2){
              this.bb = 0
              this.zhutu = this.img_src1_yl
            }
          },
          dian(index){
            this.chanpin_mark = this.xiangqing_mark[index].product
            this.xiang = 1
          },
          guanbi(){
            this.$router.go(-1)
          }
        },
        created(){
          this.get_shuju();
        }
    }
</script>

<style scoped lang="less">
  .aa{
    display:flex;
    justify-content:space-around;
    width: 100%;
    background-color:rgb(253, 249, 249);
    .bb{
      width: 80%;
      background-color: rgb(255, 255, 255);

      .cc1{
        width: 100%;
        display:flex;
        justify-content:space-between;
        align-items:center;
        height: 70px;
        background-color:rgb(253, 249, 249);
        img{
          height: 45px;
        }
        .dd1{
          display:flex;
          justify-content:space-around;
          font-size: 1.5rem;
          
          div{
            margin-left: 70px;
          }
        }
        .dd2{
          font-size: 30px;
          color: rgb(146, 145, 145);
        }
        
      }
      .cc2{
         width: 100%;
         height: 90px;
         display:flex;
         justify-content:space-around;
         align-items:center;
         .ss{
          width: 60%;
          
            .dd1{
              width: 80%;
              height: 50px;
              border-right: none;
            }
         }
         
        
      }
      .cc3{
        width: 100%;

        display:flex;
        justify-content:space-around;
        
        .ss{
          width: 100%;
          display:flex;
          .dd1{
            position: relative;
            width: 70%;
            background-color: rgb(255, 255, 255);
            .ee1{
              width: 100%;
            }
              i{
                line-height:200px;
                margin-left: 50%;
                font-size: 100px;
                
              }
            .ff2{
              width: 20px;
              height: 20px;
              background-color: rgb(255, 5, 5);
              border-radius: 50%;
              position:absolute;
              span{
                position:absolute;
                font-size: 15px;
                line-height:20px;
                left: 6px;
                color: rgb(248, 248, 248);
              }
            }
          }
          .dd2{
            width: 30%;
            background-color: rgb(255, 255, 255);
            font-size: 1.5rem;
            margin-right: 10%;
            .ee1{
              margin: 100px 0px 60px 80px;
              div{
                margin-top: 30px;
                padding-left: 10px;
                .ff1{
                  width: 80%;
                  height: 50px;
                  
                }
              }
            }
            
            
          }
          
        }
        

      }
      .cc4{
        img{
          width: 100%;
        }
      }
      .cc5{
        width: 100%;
        display:flex;
        flex-wrap: wrap;
        justify-content:space-between;
        .dd1{
          width: 18%;
          height: 200px;
          background-color: #ffffff;
          .ee1{
            width: 100%;
            height: 150px;
          }
          .ee2{
            width: 100%;
            height: 50px;
            background-color: rgb(255, 254, 254);
            text-align:center;
            vertical-align:middle;
            line-height:40px;
          }
        }
      }
      .cc6{
        img{
          width: 100%;
        }
        
      }
      .cc8{
        img{
          width: 100%;
        }
      }
      .cc10{
        img{
          width: 100%;
        }
      }
    }
  }
  .aaa{
    width: 100%;
    
    display:flex;
    justify-content:space-around;
    background-color:rgb(255, 255, 255);
    .bbb{
      width: 90%;
      margin-top: 30px;
      .ccc1{
        width: 100%;
        
        display:flex;
        justify-content:flex-start;
        flex-wrap:wrap;
        .ddd1:hover{
          transform: scale(1.1);
          box-shadow: 1px 1px 8px 4px rgb(196, 195, 195);
        }
        .ddd1{
          width: 23%;
          height: 300px;
          
          background-color: #ffffff;
          margin-bottom: 40px;
          margin-right: 2%;
          box-shadow: 0px 0px 1px 0px rgb(196, 195, 195);

          .eee1{
            width: 100%;
            height: 180px;
            overflow:hidden;
            img{
              width: 100%;
              height: 180px;
            }
          }
          .eee2{
            width: 100%;
            height: 120px;
            padding: 5px 10px 5px 10px;
            .fff1{
              width: 100%;
              height: 24px;
              overflow:hidden;
            }
            .fff2{
              width: 100%;
              height: 75px;
              font-size: 10px;
              color: #565656;
              overflow:hidden;
            }

          }
          
        }
      }
    }
  }
</style>